<h2 mat-dialog-title>{{'app.wizard.panel.content.importDialog.headline' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <p>{{'app.wizard.panel.content.importDialog.content' | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{'app.button.no' | translate}}</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{'app.button.yes' | translate}}</button>
</mat-dialog-actions>